
import { PropType, defineComponent, computed } from 'vue';

import useNumbers, { FNumFormats } from '@/composables/useNumbers';

import { DecoratedPool } from '@/services/balancer/subgraph/types';

import LiquidityAPRTooltip from '@/components/tooltips/LiquidityAPRTooltip.vue';
import { bnum } from '@/lib/utils';
import useUserInfosQuery from '@/composables/queries/useUserInfosQuery';

export default defineComponent({
  components: {
    LiquidityAPRTooltip
  },

  props: {
    userPools: { type: Object as PropType<DecoratedPool> },
    pool: { type: Object as PropType<DecoratedPool> },
    loading: { type: Boolean, default: true },
    userClaimFlakeStatus: { type: Object },
    personal: { type: Boolean, default: false },
    farmId: { type: String }
  },

  setup(props) {
    // COMPOSABLES
    const { fNum2 } = useNumbers();
    const { data: userInfosQuery, isLoading } = useUserInfosQuery({
      // @ts-ignore
      pid: props.farmId?.split('_')[1]
    });
    // COMPUTED
    const userInfos = computed(() =>
      userInfosQuery.value ? userInfosQuery.value[0] : undefined
    );

    const stats = computed(() => {
      if (!props.pool) return [];

      if (!props.personal)
        return [
          {
            id: 'tvl',
            label: 'TVL',
            value: fNum2(props.pool.totalLiquidity, FNumFormats.fiat)
          },
          {
            id: 'Basic Rewards each day',
            label: 'Basic Rewards each day',
            value: fNum2(props.pool.basicRewardsEachDay || '0')
          },
          {
            id: 'Amount of Boosting veFlake',
            label: 'Amount of Boosting veFlake',
            value: fNum2(
              bnum(props.pool.totalBoostStaked || '0')
                .dividedBy(Math.pow(10, 18))
                .toFixed(0)
            )
          },
          {
            id: 'apr',
            label: 'Basic APR',
            value: props.pool.basicAPR
              ? fNum2(props.pool.basicAPR, FNumFormats.percent)
              : '-'
          },
          {
            id: 'Boosted APR',
            label: 'Boosted APR',
            value: props.pool.basicAPR
              ? fNum2(Number(props.pool.basicAPR) * 2.5, FNumFormats.percent)
              : '-'
          }
        ];
      return [
        {
          id: 'Your value in farming',
          label: 'Your value in farming',
          value: fNum2(props.userPools?.shares || '0', {
            style: 'currency',
            maximumFractionDigits: 0,
            fixedFormat: true
          })
        },
        {
          id: 'Your Boosted APR',
          label: 'Your Boosted APR',
          value: fNum2(
            userInfos.value && userInfos.value.boostDecimals !== '0'
              ? (Number(props.pool.basicAPR) *
                  Number(userInfos.value?.boostRatio || '0')) /
                  Number(userInfos.value?.boostDecimals)
              : '0',
            FNumFormats.percent
          )
        },
        {
          id: 'Mined FLAKE',
          label: 'Mined FLAKE',
          value: fNum2(
            props.userClaimFlakeStatus
              ? bnum(props.userClaimFlakeStatus[0]?.wholePending || '0')
                  .div(Math.pow(10, 18))
                  .toFixed(0)
              : '0'
          )
        },
        {
          id: 'Your amount of',
          label: 'Your amount of boosting veFLAKE',
          value: fNum2(
            bnum(userInfos.value?.boostStaked || '0')
              .div(Math.pow(10, 18))
              .toFixed(0)
          )
        }
      ];
    });

    return {
      stats,
      isLoading
    };
  }
});
